import React from "react";
import { Line } from "react-chartjs-2";
import { euroFormatter } from "src/global";
import ChartCard from "../ChartCard";
import { withLineChartStyles } from "../chartStyles";

const RevenueChart = ({ revenueChart }) => {
  return (
    <ChartCard
      chart={revenueChart}
      summary={`Gesamt: ${euroFormatter(revenueChart.total)}`}
    >
      <Line
        data={withLineChartStyles(revenueChart.data)}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              ticks: {
                callback: function (value) {
                  return euroFormatter(value);
                },
              },
            },
          },
        }}
      />
    </ChartCard>
  );
};

export default RevenueChart;
